export var IdPackageType;
(function (IdPackageType) {
    // values can be found in balancing: packages.json
    IdPackageType["PlayerLeague"] = "playerLeague";
    IdPackageType["CoopLeague"] = "coopLeague";
    IdPackageType["CollectLeague"] = "collectLeague";
    IdPackageType["GrowingGold"] = "growingGold";
    IdPackageType["GrowingDollar"] = "growingDollar";
    IdPackageType["GrowingResource"] = "growingResource";
})(IdPackageType || (IdPackageType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdPackageType.ts
// module id = 1962
// module chunks = 3